(function (window) {

    const apps = {
        'cubefield': '/custom/cubes/index.html'
    };

    function showHtml() {
        const container = document.getElementById('htmlContainer');
        // show loading
        document.getElementById('custom-type-trial-loading').classList.add('visible');
        container.classList.add('visible');
        document.body.classList.add('with-custom-type-trial');

        let app = replaceVariables(window.firstStimColumnValue(window.trialRow));

        // allow predefined apps
        if (apps[app.toLowerCase().trim()]) {
            app = apps[app.toLowerCase().trim()]
        }

        // if it doesn't start with http, it's a relative path
        if (!app.startsWith('http')) {
            // already has .html
            if (!app.includes('.html')) {
                app += '.html';
            }
            // should not contain ../../ etc.
            app = app.replace(/^(\.\.\/?)+/, '');

            app = `./${window.stimuliVersion}/stimuli/${app}`;
        }

        // also adds current timestamp to prevent browser cache
        let urlWithQuery = appendQueryString(app, { ts: Date.now() });

        let newContainer = container.cloneNode();

        // hide loading
        newContainer.onload = function () {
            document.getElementById('custom-type-trial-loading').classList.remove('visible');
        }

        newContainer.src = urlWithQuery;
        container.replaceWith(newContainer);
        newContainer.focus();
    }

    // utils
    // append query string parameters to url
    function appendQueryString(url, params) {
        if (!params) {
            return url;
        }

        let queryStringPrefix = url.includes('?') ? '&' : '?';
        const paramsArray = [];

        for (let key in params) {
            paramsArray.push(key + '=' + params[key]);
        }

        return url + queryStringPrefix + paramsArray.join('&');
    }
    // end utils

    function saveHtmlTrialResponse(response, customVariables) {
        saveTrial(response);

        if (customVariables) {
            storeResultVariables(responses.length - 1, customVariables);
        }

        cleanHtmlTrial()
        clearTimeouts();
        endTrial();
    }

    function cleanHtmlTrial() {
        const container = document.getElementById('htmlContainer');
        container.src = "";
        container.classList.remove('visible');
        container.blur();
        document.body.classList.remove('with-custom-type-trial');
    }

    function storeResultVariables(trialRow, variablesObject) {

        for (const variableName in variablesObject) {
            if (!window.customVariables[variableName]) {
                window.customVariables[variableName] = {};
            }
            window.customVariables[variableName][trialRow] = variablesObject[variableName];
        }
    }

    window.showHtml = showHtml;
    window.cleanHtmlTrial = cleanHtmlTrial

    if (!window.testableSDK) {
        // proxies the current trial columns
        const currentTrialProxy = new Proxy({}, {
            get(_, columnName) {
                const trialRow = window.trialRow;

                if (typeof trialRow !== 'number') {
                    return undefined;
                }

                let value = undefined;

                try {
                    window.columnForTrial(columnName, trialRow);
                } catch (e) {
                    // maybe it's a custom variable
                    value = window.columnCustomForTrial(columnName, trialRow);
                }

                if (value == 'na') {
                    value = undefined;
                }

                return value;
            }
        });

        // proxies the custom variables (these are variables saved by custom html trials)
        const customVariablesProxy = new Proxy(
            {
                // create a method to get the value of a custom variable for a specific trial
                getValue: function (variableName, trialRow = -1) {

                    if (!window.customVariables) {
                        return undefined;
                    }

                    if (!window.customVariables[variableName]) {
                        return undefined;
                    }

                    // make sure the integer is an integer
                    trialRow = parseInt(trialRow) || trialRow;
                    // default to previous trial
                    if (trialRow === null || trialRow === undefined) {
                        trialRow = -1;
                    }

                    const values = window.responses;
                    // need +1 because the way we save data in customVariables. see storeResultVariables call (responses.length - 1)
                    const computedIndex = window.translateValueToIndex(trialRow, values, null, 1) + 1;

                    const propertiesReversed = Object.keys(window.customVariables[variableName]).sort(
                        (a, b) => parseInt(b) - parseInt(a)
                    );

                    // find the first trial row that is less than or equal to the current trial row
                    const closestTrialRow = propertiesReversed.find(trialRow => trialRow <= computedIndex);

                    if (!closestTrialRow) {
                        return undefined;
                    }

                    return window.customVariables[variableName][closestTrialRow];
                }
            },
            {
                get(target, property) {
                    if (property in target) {
                        return target[property];
                    }

                    if (property in window.customVariables) {
                        return target.getValue(property, -1);
                    }

                    return undefined;
                },
            }
        );

        window.testableSDK = {
            /**
             * Getter for allocated subject groups.
             * 
             * @returns {Array<string>} An array of subject groups allocated to the participant, as defined in the trial file.
             */
            get allocatedSubjectGroups() {
                let groups = window.pickedSubjectGroups;

                // if is not array or doesn't have at least one element return empty array
                if (!Array.isArray(groups) || groups.length < 1) {
                    return [];
                }

                // remove the default group level (added automatically by Testable, i.e. nsg:0)
                return groups.map(function (group) {
                    return group.replace('nsg:', '');
                });
            },

            get trial() {
                return currentTrialProxy;
            },

            get variables() {
                return customVariablesProxy;
            },
        }
    };
    window.testableSDK.saveHtmlTrialResponse = saveHtmlTrialResponse;
    // for cross domain
    const onResponseMessage = function (event) {
        // data = {
        //      testable_app_result: {
        //          response: ...,
        //          custom_variables: ...,
        //      }
        // }
        if (event.data.testable_app_result) {
            // save the response
            saveHtmlTrialResponse(
                event.data.testable_app_result.response,
                event.data.testable_app_result.custom_variables
            );
        }
    }
    // make sure we are not listening already
    window.removeEventListener("message", onResponseMessage);
    window.addEventListener("message", onResponseMessage, false);

})(window);